import { useCallback } from "react";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";
import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { convertToInput as convertToRoomPriceRankDailyStatusInput } from "../../_shared/daily-stasus/repository/mutation/update-room-price-daily-status/composition/convert-to-input";
import { useUpdateRoomPriceRankDailyStatus } from "../../_shared/daily-stasus/repository/mutation/update-room-price-daily-status/use-update-room-price-daily-status";
import { convertToInput as convertToRoomPriceRankMastInput } from "../../_shared/price-rank/repository/mutation/update-room-price-rank/composition/convert-to-input";
import { useUpdateRoomPriceRank } from "../../_shared/price-rank/repository/mutation/update-room-price-rank/use-update-room-price-rank";

import type { ProductRoomPriceRankDailyStatusFormModel } from "../../_shared/daily-stasus/type";
import type { ProductRoomPriceRankFormModel } from "../../_shared/price-rank/type";

export const useUpdateRoomPriceSetting = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc: updateRoomPriceRank } = useUpdateRoomPriceRank();
	const { mutationFunc: updateRoomPriceRankDailyStatus } = useUpdateRoomPriceRankDailyStatus();

	const onUpdate = useCallback(
		async ({
			roomPriceRankViewModel, //
			roomPriceRankDailyStatusViewModel,
			successCallback,
		}: {
			roomPriceRankViewModel: ProductRoomPriceRankFormModel["ViewModel"]; //
			roomPriceRankDailyStatusViewModel: ProductRoomPriceRankDailyStatusFormModel["ViewModel"];
			successCallback: () => void;
		}) => {
			showLoadingScreenCallback();

			const roomPriceRankMastInput = convertToRoomPriceRankMastInput({ viewModel: roomPriceRankViewModel });
			const roomPriceRankDailyStatusInput = convertToRoomPriceRankDailyStatusInput({
				viewModel: roomPriceRankDailyStatusViewModel,
			});

			const { errors: updateRoomPriceRanksError } = await updateRoomPriceRank({
				variables: {
					input: roomPriceRankMastInput,
				},
			});

			const { errors: updateRoomPriceRankDailyStatusError } = await updateRoomPriceRankDailyStatus({
				variables: {
					input: roomPriceRankDailyStatusInput,
				},
				refetchQueries: [
					{
						query: START_GUIDE_QUERY,
						variables: { hotelID: roomPriceRankDailyStatusInput.hotelID },
					},
				],
			});

			hideLoadingScreenCallback();

			if (!updateRoomPriceRanksError && !updateRoomPriceRankDailyStatusError) {
				notifyUserEventInfo({
					title: "部屋料金ランクの設定を更新しました",
				});
				successCallback();
			}
		},
		[hideLoadingScreenCallback, showLoadingScreenCallback, updateRoomPriceRank, updateRoomPriceRankDailyStatus],
	);

	return {
		onUpdate,
	};
};
